import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useUser } from "./UserContext";

/**
 * Route guard for the rate card creation wizard (`/rates/create`).
 *
 * Only users holding the `create:rates` permission who are not SalesPersons
 * may reach the wizard (the API enforces the same permission on
 * `POST /v1/rate-cards`). SalesPersons and users without the permission are
 * redirected to the rates list.
 */
export function RateCreateRoute({ children }: { children: ReactNode }) {
  const { canCreateRates, isProfileLoading, profile } = useUser();

  if (isProfileLoading || profile == null) return null;

  if (!canCreateRates) {
    return <Navigate to="/rates" replace />;
  }

  return <>{children}</>;
}
